// Headless export registration for Heatmap (composite: background image + overlay SVG
// + optional cluster shapes). Single-output. The live cj Chart is reused as-is — the
// export hook lives in its ActionButtons child and reuses the SAME `buildSvgForExport`
// composite builder the live Download-PNG button uses (per-view-mode image embed:
// spotlight → <image id=image-source>, overlay/overlayclusters → <feImage>, default →
// inserted <image>, original → bare wrapper). Key `hm` is the legacy pptx.coffee
// dispatch key (Option A).
//
// The BE sends the full `image` object (id/uid/original.{url,path,width,height}) exactly
// as the live question schema does (asset_json_image) — NEVER base64. ActionButtons
// converts the URL to base64 on the render route via its existing loadImageAsBase64,
// identical to the live Download-PNG path.
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/07-hm.md §4

import { ExportableCharts } from '@aytm/app/stats/page/question-views/components/charts/lib/exportable'
import { CLUSTER_FORM_MODE } from '@aytm/app/stats/page/question-views/hm/components/controls/lib/constants'

import HeatmapChart from '@aytm/app/stats/page/question-views/hm/components/chart/Chart'

ExportableCharts.register('hm', {
  Component: HeatmapChart,
  toProps: (data: any, params: any) => ({
    id: data.id,
    // Full image object from the BE schema; ActionButtons fetches base64 from its URL.
    image: data.image,
    answer: data.answer,
    viewMode: params.viewMode || 'heatmap',
    clustersMode: params.clustersMode || 'clusters-off',
    clusters: data.clusters || [],
    batches: data.batches || [],
    config: data.config || {},
    questionKey: data.questionKey,
    // OFF keeps the Lasso overlay from mounting; interactive props stay undefined.
    clusterFormMode: CLUSTER_FORM_MODE.OFF,
    activeClusterId: null,
    userRoles: [],
    loading: false,
    lassoCluster: undefined,
    changeClustersForm: undefined,
    onLassoChange: undefined,
    onTipChange: undefined
  })
})
